const updateGuidelineRoot = function() {
    document.getElementById('guideline').style.transition = 'none'
    setTimeout(() => {
        var contentOffsetHeight = document.getElementById('content').offsetHeight
        var guidelineHeight = contentOffsetHeight - 80;
        maxY = guidelineHeight - 70;
        document.getElementById('guideline').style.height = guidelineHeight+'px'
     }, 200);
}

export { updateGuidelineRoot }



// WEBPACK FOOTER //
// ./resources/js/helper.js